<template>
  <modal max-width="500px">
    <template #activator="props">
      <button
        @click="orderCard(props.onClick)"
        class="p-2 px-4 bg-green-500 hover:bg-green-600 text-white rounded-md"
      >
        <button-loading-indicator v-show="isLoading" />
        Оформить карту
      </button>
    </template>

    <template #default="{ close }">
      <div
        v-if="isOk"
        class="bg-white rounded-md p-4 shadow-lg px-8"
        style="width: 30rem"
      >
        <div class="flex justify-center py-4">
          <vue-feather
            stroke-width="1"
            class="w-32 fill-current text-green-400"
            type="check-circle"
          ></vue-feather>
        </div>
        <div>
          Заявка на оформление успешно создана. Пожалуйста подождите пока наш
          оператор её обработает.
        </div>
        <div class="flex justify-center">
          <button
            class="
              px-4
              py-2
              ring-1 ring-gray-200
              rounded-md
              bg-gray-200
              hover:bg-gray-300
              transform
              transition-transform
              duration-100
              hover:scale-105
            "
            @click="close"
          >
            Продолжить
          </button>
        </div>
      </div>
      <div
        v-else
        class="bg-white rounded-md p-4 shadow-lg px-8"
        style="width: 30rem"
      >
        <div class="flex justify-center py-4">
          <vue-feather
            stroke-width="1"
            class="w-32 fill-current text-red-400"
            type="x-circle"
          ></vue-feather>
        </div>
        <div>
          К сожалению, в ходе оформления заявки возникла непредвиденная
          ошибка.<br />
          Возможно сайт сейчас обновляется, попробуйте позднее.
        </div>
        <div class="flex justify-center">
          <button
            class="
              px-4
              py-2
              ring-1 ring-gray-200
              rounded-md
              bg-gray-200
              hover:bg-gray-300
              transform
              transition-transform
              duration-100
              hover:scale-105
            "
            @click="close"
          >
            Продолжить
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import { Modal } from "vue-neat-modal";
import { orderCard } from "@/api/api";
import ButtonLoadingIndicator from "@/components/util/ButtonLoadingIndicator";
import { object, string, setLocale } from "yup";

setLocale({
  mixed: {
    required: "Поле '${label}' обязательно к заполнению",
  },
  string: {
    email: "Поле '${label}' заполнено неверно.",
    min: "Поле '${label}' должно содержать больше символов.",
    max: "Поле '${label}' должно содержать меньше символов.",
  }
})

export default {
  name: "OrderCardButtonModal",
  components: {
    ButtonLoadingIndicator,
    Modal,
  },
  props: {
    cardParams: {
      type: Object,
      required: true,
    },
    isValid: {
      type: Boolean,
      required: true,
    },
  },
  emits: {
    "card-params-validation-error": null,
  },
  data() {
    let schema = object({
      phoneNumber: string().required().min(5).max(50).label("телефон"),
      name: string().required().min(2).max(100).label("имя"),
      cardType: string().required().label("тип карты"),
    });

    return {
      isOk: false,
      isLoading: false,
      schema,
    };
  },
  methods: {
    orderCard(callback) {
      let isValid = this.validateCardParams(this.cardParams);

      if (isValid) {
        this.isLoading = true;

        orderCard(this.cardParams)
          .then(() => {
            this.isOk = true;
            callback();
          })
          .catch(() => {
            this.isOk = false;
            callback();
          })
          .finally(() => (this.isLoading = false));
      }
    },
    validateCardParams(cardParams) {
      try {
        this.schema.validateSync(cardParams);
        return true;
      } catch (err) {
        this.$emit("card-params-validation-error", err);
      }
    },
  },
};
</script>

<style scoped></style>
